import { type FC, useCallback, useState } from 'react';

import { Box } from '../Box';
import { accordionStyles } from './Accordion.styles';
import { type AccordionProps } from './Accordion.types';
import AccordionItem from './components/AccordionItem';

const Accordion: FC<AccordionProps> = ({
  items,
  allowMultiple = false,
  defaultOpenIds = [],
  className,
}) => {
  const [openIds, setOpenIds] = useState<Set<string>>(
    () => new Set(defaultOpenIds)
  );

  const handleToggle = useCallback(
    (id: string) => {
      setOpenIds((prev) => {
        const next = new Set(prev);

        if (next.has(id)) {
          next.delete(id);
          return next;
        }

        if (!allowMultiple) {
          return new Set([id]);
        }

        next.add(id);
        return next;
      });
    },
    [allowMultiple]
  );

  return (
    <Box css={accordionStyles} className={className}>
      {items.map((item, index) => (
        <AccordionItem
          key={item.id}
          id={item.id}
          title={item.title}
          content={item.content}
          isOpen={openIds.has(item.id)}
          onToggle={() => handleToggle(item.id)}
          showDivider={index < items.length - 1}
        />
      ))}
    </Box>
  );
};

export default Accordion;
